var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"zoom"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mustShow),expression:"mustShow"}],staticClass:"mainTitle"},[_c('div',{staticClass:"blocktitle"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }